/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30c015c92983f12628a8b3ef2adf643d>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _UNSAFE_baseNew = _interopRequireDefault(require("@atlaskit/icon/UNSAFE_base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const BugIcon = props => /*#__PURE__*/_react.default.createElement(_UNSAFE_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.75 4.75V4a2.25 2.25 0 0 1 4.5 0v.75m1.25.75a.75.75 0 0 0-.75-.75h-5.5a.75.75 0 0 0-.75.75m7 0 1.64-1.17a.5.5 0 0 0 .165-.205L14.25 2M11.5 5.5v2.25m-7-2.25L2.86 4.33a.5.5 0 0 1-.165-.205L1.75 2M4.5 5.5v2.25m7 0h4m-4 0V10m-7-2.25h-4m4 0V10m7 0a3.25 3.25 0 0 1-3.25 3.25h-.249a3.5 3.5 0 0 1-3.457-2.967L4.5 10m7 0 1.42 1.183a.5.5 0 0 1 .127.16l1.203 2.407M4.5 10l-1.42 1.183a.5.5 0 0 0-.127.16L1.75 13.75"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
BugIcon.displayName = 'BugIcon';
var _default = exports.default = BugIcon;